import { useEffect, useState } from "react";

import { apiFetch } from "../api/apiFetch";

export const FEATURE_EXTENDED_ACTIVE_SPRINT_CAPACITY = "extended_active_sprint_capacity";
export const FEATURE_EXTENDED_GOAL_CAPACITY = "extended_goal_capacity";
export const FEATURE_EXTENDED_ACTION_CAPACITY = "extended_action_capacity";
export const FEATURE_WEEKLY_SUMMARY_HISTORY_FULL = "weekly_summary_history_full";
export const FEATURE_SHARED_HISTORY_FULL = "shared_history_full";

export const LIMIT_ACTIVE_SPRINTS = "active_sprints";
export const LIMIT_ACTIVE_GOALS = "active_goals";
export const LIMIT_ACTIVE_ACTIONS = "active_actions";

const DEFAULT_FEATURES = {
  [FEATURE_EXTENDED_ACTIVE_SPRINT_CAPACITY]: false,
  [FEATURE_EXTENDED_GOAL_CAPACITY]: false,
  [FEATURE_EXTENDED_ACTION_CAPACITY]: false,
  [FEATURE_WEEKLY_SUMMARY_HISTORY_FULL]: false,
  [FEATURE_SHARED_HISTORY_FULL]: false,
};

const DEFAULT_LIMITS = {
  [LIMIT_ACTIVE_SPRINTS]: 1,
  [LIMIT_ACTIVE_GOALS]: 3,
  [LIMIT_ACTIVE_ACTIONS]: 5,
};

export function useEntitlements() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    apiFetch("/billing/status/")
      .then((result) => {
        if (active) setData(result || null);
      })
      .catch(() => {
        if (active) setData(null);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return {
    loading,
    data,
    isPlus: Boolean(data?.plan?.premiumActive ?? data?.active),
    features: {
      ...DEFAULT_FEATURES,
      ...(data?.features || {}),
    },
    limits: {
      ...DEFAULT_LIMITS,
      ...(data?.limits || {}),
    },
  };
}
